import { AnimationCallbackEvent, Directive, Input } from '@angular/core';

const EASING = 'ease-in-out';

/**
 * Раскрытие и сворачивание блока по высоте при появлении и удалении.
 * Вешается на элемент внутри `@if`: работает на нативных
 * `animate.enter` / `animate.leave` Angular и Web Animations API, высоту измеряет по `scrollHeight`,
 * поэтому разметку оборачивать не нужно.
 *
 * ```html
 * @if (isOpen) {
 *   <div appHeightCollapse [appHeightCollapseDuration]="300">…</div>
 * }
 * ```
 */
@Directive({
  selector: '[appHeightCollapse]',
  host: {
    '(animate.enter)': 'onEnter($event)',
    '(animate.leave)': 'onLeave($event)',
  },
})
export class HeightCollapseDirective {
  /** Длительность в мс, как `params.duration` у `tuiHeightCollapse` */
  @Input() appHeightCollapseDuration = 300;

  onEnter({ target }: AnimationCallbackEvent): void {
    this.animate(target, [{ height: '0px' }, { height: `${target.scrollHeight}px` }]);
  }

  onLeave({ target, animationComplete }: AnimationCallbackEvent): void {
    const animation = this.animate(target, [
      { height: `${target.scrollHeight}px` },
      { height: '0px' },
    ]);

    if (animation) {
      animation.onfinish = () => animationComplete();
      animation.oncancel = () => animationComplete();
    } else {
      animationComplete();
    }
  }

  private animate(target: Element, keyframes: Keyframe[]): Animation | null {
    if (typeof target.animate !== 'function') {
      return null;
    }

    return target.animate(keyframes, {
      duration: this.appHeightCollapseDuration,
      easing: EASING,
    });
  }
}
